import { PERMISSIONS } from '@lms/shared-types';

export interface StaffAttemptActions {
  viewDetail: boolean;
  review: boolean;
  quickReview: boolean;
  edit: boolean;
  delete: boolean;
}

/** Acciones de la fila de intentos. Revisar reemplaza a Ver detalle. */
export function staffAttemptActions(status: string, permissions: readonly string[]): StaffAttemptActions {
  const canManageAttempts = permissions.includes(PERMISSIONS.EVALUACIONES_INTENTOS_GESTIONAR);
  const review = canManageAttempts && status === 'pending_review';

  return {
    viewDetail: !review,
    review,
    quickReview: canManageAttempts && status === 'pending_review',
    edit: canManageAttempts,
    delete: canManageAttempts,
  };
}
